import { Box, IconButton, keyframes, styled, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Logo } from '../constant';

const jump = keyframes`
  0% { transform: translateY(0); opacity: 0.4; }
  50% { transform: translateY(-15px); opacity: 1; }
  100% { transform: translateY(0); opacity: 0.4; }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Dot = styled(Box)(({ theme }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: "#fff",
  margin: '0 4px',
  animation: `${jump} 1.2s ease-in-out infinite`,

  '&:nth-of-type(2)': {
    animationDelay: '0.4s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '0.8s',
  },
}));


const LoadingScreen = ({ loadingData }) => {
  console.log(loadingData);
  const [showQuote, setShowQuote] = useState(true);
  const dataType = loadingData?.[0]?.type?.toLowerCase()?.trim() || "";

  const logoAnimation = keyframes`
    0% { opacity: 0; transform: translateY(20px) scale(0.8); }
    100% { opacity: 1; transform: translateY(0) scale(1); }
  `;

  const floatAnimation = keyframes`
    0% { transform: translateY(0px); }
    50% { transform: translateY(-12px); }
    100% { transform: translateY(0px); }
  `;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {dataType === "only image" ?
        <>
          <Box
            component="img"
            src={loadingData?.[0]?.image}
            alt="Image"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              animation: `
      ${logoAnimation} 1s ease-out,
      ${floatAnimation} 3s ease-in-out infinite
    `,
              filter: "drop-shadow(0 0 30px rgba(51,191,255,0.4))",
            }}
          />

          <Box
            display="flex"
            sx={{
              mt: 4,
              justifyContent: {
                xs: "center",
                md: "flex-start",
              },
            }}
          >
            <Dot />
            <Dot />
            <Dot />
          </Box>
        </>


        : dataType === "only text" ?
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              width: "80%",
            }}
          >

            <Typography
              sx={{
                color: "#8C8CC2",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
                lineHeight: 1.6,
                fontSize: {
                  xs: "16px",
                  sm: "18px",
                  md: "24px",
                },
                animation: `${fadeIn} 1s ease-out`,
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
            >
              {loadingData?.[0]?.text}
            </Typography>


            <Box
              display="flex"
              sx={{
                mt: 4,
                justifyContent: {
                  xs: "center",
                  md: "flex-start",
                },
              }}
            >
              <Dot />
              <Dot />
              <Dot />
            </Box>
          </Box>

          : dataType === "image and text" ?
            < Box
              sx={{
                width: "100%",
                maxWidth: "1400px",
                mx: "auto",
                px: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "60vh",
                  gap: { xs: 4, md: 8 },
                }}
              >
                {/* Left Side Image */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box
                    component="img"
                    src={loadingData?.[0]?.image}
                    alt="Image"
                    sx={{
                      width: "100%",
                      maxWidth: "500px",
                      maxHeight: "500px",
                      objectFit: "contain",
                      animation: `${fadeIn} 1s ease-out`,
                    }}
                  />
                </Box>

                {/* Right Side Text */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: { xs: "center", md: "flex-start" },
                    textAlign: { xs: "center", md: "left" },
                    width: "100%",
                  }}
                >
                
                    <Typography
                      sx={{
                        color: "#8C8CC2",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        lineHeight: 1.6,
                        fontSize: {
                          xs: "16px",
                          sm: "18px",
                          md: "24px",
                        },
                        animation: `${fadeIn} 1s ease-out`,
                        textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                      }}
                    >
                      {loadingData?.[0]?.text}
                    </Typography>
              

                  <Box
                    display="flex"
                    sx={{
                      mt: 6,
                      justifyContent: {
                        xs: "center",
                        md: "flex-start",
                      },
                    }}
                  >
                    <Dot />
                    <Dot />
                    <Dot />
                  </Box>
                </Box>
              </Box>
            </Box>

            :
            <Box
              display="flex"
              sx={{
                mt: 4,
                justifyContent: {
                  xs: "center",
                },
              }}
            >
              <Dot />
              <Dot />
              <Dot />
            </Box>
      }
    </Box >
  );
};

export default LoadingScreen;